export default {
    lista: {
        method: 'get',
        url: 'folhar/lista'
    },
    pesquisa: {
        method: 'get',
        url: 'folhar/pesquisa{/id}'
    },
    cadastra: {
        method: 'post',
        url: 'folhar/cadastro'
    },
    delete: {
        method: 'delete',
        url: 'folhar/deletar{/id}'
    },
    editar: {
        method: 'get',
        url: 'folhar/editar{/id}'
    },
    update: {
        method: 'post',
        url: 'folhar/update'
    },
    servico: {
        method: 'post',
        url: 'boletins/tabela/tomador'
    },
    servicogeral: {
        method: 'post',
        url: 'boletins/tabela/geral'
    },
    basecalculo: {
        method: 'post',
        url: 'basecalculo/cadastro'
    },
    basecalculodelete: {
        method: 'delete',
        url: 'basecalculo/deletar{/id}'
    },
    valorcalculo: {
        method: 'post',
        url: 'boletins/tabela/rublicas'
    },
    valorcalculocadastro: {
        method: 'post',
        url: 'valorcalculo/cadastro'
    },
    valorcalculogeral: {
        method: 'post',
        url: 'boletins/tabela/rublicas/geral'
    },
    comissionador: {
        method: 'get',
        url: 'comissionado/busca{/trabalhador}{/tomador}'
    },
    dias: {
        method: 'post',
        url: 'relacaodia/busca'
    },
    diascadastro: {
        method: 'post',
        url: 'relacaodia/cadastro'
    },
    quinzena: {
        method: 'post',
        url: 'folhar/primeira/quinzena'
    },
    evento: {
        method: 'get',
        url: 'folhar/evento/1200{/id}'
    },
    eventofechamento: {
        method: 'post',
        url: 'folhar/evento1299/cadastro'
    },
    eventoabertura: {
        method: 'post',
        url: 'folhar/evento1298/cadastro'
    },
    eventoupdate: {
        method: 'put',
        url: 'evento/update'
    },
    bancos: {
        method: 'get',
        url: 'folhar/banco{/id}'
    },
    rublicas: {
        method: 'get',
        url: 'folhar/rublicas{/id}'
    },
    tomadores: {
        method: 'get',
        url: 'folhar/tomadores{/id}'
    },
    automatico: {
        method: 'get',
        url: 'folhar/auto/lista'
    },
    // dias:{
    //     method:'get',
    //     url:'folhar/calendario/lista'
    // },
    configtrabalhador: {
        method: 'get',
        url: 'trabalhador/auto/lista'
    },
    trabalhadores: {
        method: 'post',
        url: 'folhar/calculo/trabalhador'
    },
    folhatomador: {
        method: 'post',
        url: 'folhar/calculo/tomador'
    },
    folhageral: {
        method: 'post',
        url: 'folhar/calculo/geral'
    },
    cadastra1270: {
        method: 'post',
        url: 'folhar/evento1270/cadastro'
    },
    delete1270: {
        method: 'delete',
        url: 'folhar/evento1270/deletar{/id}'
    },
    update1270: {
        method: 'put',
        url: 'folhar/evento1270/update'
    },
    folharboletim: {
        method: 'post',
        url: 'boletins/tabela/folhar/quantidade'
    },
}